<template>
                  <tr>
                    <td class="table-title"><b>{{ product.title }}</b><br />{{ product.subtitle }}<br /><i>{{ product.condition }}</i></td>
                    <td class="table-description">{{ product.description }}</td>
                    <td v-if="product.price != 0"><b>&pound;{{ product.price }}</b></td>
                    <td v-if="product.price == 0"><b><i class="fa fa-phone"></i> Call</b></td>
                  </tr>
</template>

<script>

export default {
  name: 'books',
  props: ['product'],
};
</script>



// WEBPACK FOOTER //
// src/pages/selling/books.vue